import { Link } from "react-router-dom";
import { Plus, Star } from "lucide-react";
import { useStore } from "../context/Store";

export const ProductCard = ({ p }) => {
  const { fmt, addToCart } = useStore();
  const off = p.original_price_usd > p.price_usd ? Math.round((1 - p.price_usd / p.original_price_usd) * 100) : 0;
  return (
    <div data-testid={`product-card-${p.id}`} className="group bg-white rounded-2xl overflow-hidden border border-[#C85A32]/10 hover:shadow-[0_12px_40px_-12px_rgba(200,90,50,0.35)] hover:-translate-y-1 transition-[transform,box-shadow] duration-300 flex flex-col">
      <Link to={`/product/${p.id}`} className="relative aspect-square overflow-hidden bg-stone-100">
        <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
        {off > 0 && <span className="absolute top-3 left-3 bg-[#C85A32] text-white text-xs font-bold px-2 py-1 rounded-full">-{off}%</span>}
      </Link>
      <div className="p-3.5 flex flex-col flex-1">
        <Link to={`/product/${p.id}`} className="text-sm text-stone-700 line-clamp-2 leading-snug min-h-[2.5rem] hover:text-[#C85A32] transition-colors">{p.title}</Link>
        <div className="flex items-center gap-1 text-xs text-stone-500 mt-1.5">
          <Star className="w-3.5 h-3.5 fill-[#D99B26] text-[#D99B26]" /> {p.rating?.toFixed(1)} <span className="truncate">· {p.sold || "New"}</span>
        </div>
        <div className="flex items-end justify-between mt-auto pt-2">
          <div>
            <div data-testid="product-card-price" className="font-display text-lg font-extrabold text-[#1A1714]">{fmt(p.price_usd)}</div>
            {off > 0 && <div className="text-xs text-stone-400 line-through">{fmt(p.original_price_usd)}</div>}
          </div>
          <button data-testid={`add-to-cart-${p.id}`} onClick={() => addToCart(p)} className="w-9 h-9 rounded-full bg-[#1A1714] text-white grid place-items-center hover:bg-[#C85A32] active:scale-90 transition-[background-color,transform]">
            <Plus className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};
